//INITIAL FLOW
import * as types from "./actionTypes";

export const addNewQuote = () => ({
  type: types.ADD_NEW_QUOTE,
  payload: {}
});

export const setQuotes = (quotes) => ({
  type: types.SET_QUOTES,
  payload: {quotes}
});

export const updateQuote = (quote, updatedQuote) => ({
  type: types.UPDATE_QUOTE,
  payload: {quote, updatedQuote}
});

export const setActiveQuoteIndex = (activeQuoteIndex) => ({
  type: types.SET_ACTIVE_QUOTE_INDEX,
  payload: {activeQuoteIndex}
});
